import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import { WebChatFontSize } from "../../state/webChat/types";
import WebFont from 'webfontloader';
import classes from './index.module.scss';
const ChatBox = ({ alignLeft = false, children, fontSize, fontFamily, }) => {
    const [visibility, setVisibility] = useState('hidden');
    const [fontReady, setFontReady] = useState(false);
    useEffect(() => {
        // of cycle rendering to avoid showing this box in a small window (until iframe has resized)
        setTimeout(() => setVisibility('visible'), 0);
    }, []);
    useEffect(() => {
        if (fontFamily) {
            const font = document.querySelectorAll(`link[href*="family=${fontFamily === null || fontFamily === void 0 ? void 0 : fontFamily.replaceAll(' ', '+')}"]`);
            if ((font === null || font === void 0 ? void 0 : font.length) > 0) {
                setFontReady(true);
            }
            else {
                WebFont.load({
                    google: {
                        families: [fontFamily],
                    },
                    active: () => setFontReady(true),
                });
            }
        }
    }, [fontFamily]);
    return (_jsx("section", Object.assign({ style: Object.assign({ visibility: visibility }, (fontReady && fontFamily && { fontFamily })), className: classNames(classes.box, {
            [classes.alignLeft]: alignLeft,
            [classes.alignRight]: !alignLeft,
            [classes.customFont]: fontFamily,
            [classes.largeFont]: fontSize === WebChatFontSize.LARGE,
            [classes.smallFont]: fontSize === WebChatFontSize.SMALL,
        }) }, { children: children }), void 0));
};
export default ChatBox;
//# sourceMappingURL=index.js.map